(() => {
  const selector = '.cc-main-product';
  const update = (root) => {
    root.querySelectorAll('.product-info__add-button #klaviyo-bis-button-container button[data-a11y-identifier^="bis-button-"]').forEach((button) => {
      if (button.textContent.trim().toLowerCase() === 'get a restock alert' &&
          button.textContent !== 'Get a restock alert') {
        button.textContent = 'Get a restock alert';
      }
    });
  };
  document.querySelectorAll(selector).forEach((root) => {
    update(root);
    new MutationObserver(() => update(root)).observe(root, { childList: true, subtree: true, characterData: true });
  });
})();

